var map = {
	"./af.json": 2914,
	"./am.json": 91,
	"./ar.json": 5310,
	"./az.json": 9686,
	"./be.json": 5144,
	"./bg.json": 4378,
	"./bn.json": 7581,
	"./bs.json": 2086,
	"./ca.json": 8109,
	"./co.json": 7639,
	"./cs.json": 3571,
	"./cy.json": 8533,
	"./da.json": 9914,
	"./de.json": 5894,
	"./el.json": 4524,
	"./en.json": 4174,
	"./eo.json": 537,
	"./es.json": 6725,
	"./et.json": 6004,
	"./eu.json": 6727,
	"./fa.json": 3248,
	"./fi.json": 6808,
	"./fr.json": 4605,
	"./fy.json": 3272,
	"./ga.json": 5593,
	"./gd.json": 2210,
	"./gl.json": 4346,
	"./gu.json": 6813,
	"./ha.json": 8742,
	"./he.json": 6282,
	"./hi.json": 3134,
	"./hr.json": 6759,
	"./ht.json": 6645,
	"./hu.json": 6938,
	"./hy.json": 4638,
	"./id.json": 5176,
	"./ig.json": 981,
	"./is.json": 433,
	"./it.json": 3672,
	"./ja.json": 7980,
	"./jv.json": 9373,
	"./ka.json": 9173,
	"./kk.json": 7699,
	"./km.json": 89,
	"./kn.json": 412,
	"./ko.json": 9423,
	"./ku.json": 8001,
	"./ky.json": 6861,
	"./la.json": 322,
	"./lb.json": 2835,
	"./lo.json": 9540,
	"./lt.json": 5449,
	"./lv.json": 1103,
	"./mg.json": 1161,
	"./mi.json": 139,
	"./mk.json": 4165,
	"./ml.json": 8308,
	"./mn.json": 2982,
	"./mr.json": 5090,
	"./ms.json": 4525,
	"./mt.json": 3644,
	"./my.json": 7243,
	"./ne.json": 484,
	"./nl.json": 4943,
	"./no.json": 7086,
	"./ny.json": 3888,
	"./or.json": 5204,
	"./pa.json": 8190,
	"./pl.json": 1029,
	"./ps.json": 6860,
	"./pt.json": 7741,
	"./ro.json": 2354,
	"./ru.json": 4600,
	"./rw.json": 4986,
	"./sd.json": 2734,
	"./si.json": 3701,
	"./sk.json": 347,
	"./sl.json": 7110,
	"./sm.json": 8145,
	"./sn.json": 2756,
	"./so.json": 8151,
	"./sq.json": 8141,
	"./sr.json": 8912,
	"./st.json": 4206,
	"./su.json": 8665,
	"./sv.json": 8252,
	"./sw.json": 4319,
	"./ta.json": 7610,
	"./te.json": 3718,
	"./tg.json": 4996,
	"./th.json": 7549,
	"./tk.json": 2768,
	"./tl.json": 1897,
	"./tr.json": 9755,
	"./tt.json": 9361,
	"./ug.json": 3697,
	"./uk.json": 2749,
	"./ur.json": 1946,
	"./uz.json": 7906,
	"./vi.json": 1496,
	"./xh.json": 5033,
	"./yi.json": 671,
	"./yo.json": 13,
	"./zh.json": 9527,
	"./zu.json": 2816
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4595;